import { render, staticRenderFns } from "./ModalPlanPagoUniversidad.vue?vue&type=template&id=515a334d"
import script from "./ModalPlanPagoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalPlanPagoUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports